<template>
  <div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">筛选查询</div>
      </div>
      <!-- 搜索筛选 -->
      <div>
        <div class="table_item_box">
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">批次号</div>

              <input
                v-model="screen.name"
                placeholder="请输入批次号"
                class="table_item_input"
              />
            </div>
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">运单号</div>
              <input
                v-model="screen.ordernumber"
                placeholder="请输入运单号"
                class="table_item_input"
              />
            </div>
          </div>
          <div class="table_item_box_l">
            <div class="table_item_box_l_r">
              <div class="fill_in_title">国内单号</div>

              <input
                v-model="screen.aeronumber"
                placeholder="请输入国内单号"
                class="table_item_input"
              />
            </div>
          </div>

          <div class="table_item_box_s" style="flex-direction: column-reverse">
            <div class="table_item_box_l_r"></div>
            <div class="table_item_box_l_s">
              <el-button type="primary" class="round_btn" round @click="search"
                >搜索</el-button
              >
              <el-button round @click="reset">重置</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box">
      <div class="content_box_title">
        <div class="circle_l"></div>
        <div class="circle_r"></div>
        <div class="text_xl">待派送批次管理</div>
      </div>
      <div class="table_box">
        <el-table
          v-loading="tableLoading"
          :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
          ref="multipleTable"
          :data="orderData.content"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          >
          <el-table-column align="center" type="selection" width="55">
          </el-table-column>

          <el-table-column align="center" prop="name" label="批次号">
          </el-table-column>
          <el-table-column align="center" prop="totalWeightKg" label="总重量">
          </el-table-column>
          <el-table-column align="center" prop="number" label="包裹数">
          </el-table-column>
          <el-table-column align="center" prop="storagecost" label="总仓储费">
          </el-table-column>
          <el-table-column align="center" prop="duty" label="关税">
          </el-table-column>
          <el-table-column
            align="center"
            prop="districtadditionalcost"
            label="地区附加费"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="totalShippingCost"
            label="总费用"
          >
          </el-table-column>

          <el-table-column align="center" label="详情">
            <template slot-scope="scope">
              <el-button @click="details(scope.row.id, scope.row)" type="text"
                >查看批次详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="paging_box">
          <el-pagination
            @current-change="pageChange"
            background
            layout="prev, pager, next"
            :total="orderData.totalElements"
          >
          </el-pagination>
        </div>
      </div>
      <div class="step_box_s">
        <div class="last_step_l margin_right" @click="delivery()">送货</div>
      </div>
    </div>
    <el-dialog
      :center="true"
      title="第一步：确认送货信息"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <div class="fill_in_list">
        <div class="fill_in_list_l">
          <div class="fill_in_title">送货地址</div>
        </div>
        
        <input
          value="武汉市洪山区光谷大道70号现代光谷世贸中心I栋4楼"
          type="text"
          class="input_select"
          placeholder="请输入国内快递单号"
        />
      </div>
      <el-button type="text" class="text_btn">选择其他地址></el-button>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" class="confirm_btn" @click="toSelectRoute"
          >下一步</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :center="true"
      title="第二步：确认送货费用"
      :visible.sync="dialogVisibleTwo"
      width="30%"
      :before-close="handleClose"
    >
      <el-divider></el-divider>
      <div class="fill_in_list_fg">
        <div class="text_iop">送货费:</div>
        <div class="text_iop text_line">455</div>
      </div>
      <div class="fill_in_list_fg">
        <div class="text_iop">运费:</div>
        <div class="text_iop text_line">455</div>
      </div>
      <div class="fill_in_list_fg">
        <div class="text_iop">总费用:</div>
        <div class="text_iop text_line">455</div>
      </div>
      <div class="fill_in_list_fg">
        <div class="text_iop">余额:</div>
        <div class="text_iop text_line">455</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" class="confirm_btn" @click="toSelectRoute"
          >确认送货</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      tableLoading: "",
      activeName: "first",
      dialogVisible: false,
      dialogVisibleTwo: false,
      orderData: [],
      screen: {
        page: 1,
        size: 10,
        name: "",
        ordernumber: "",
        aeronumber: "",
        queryType: 2,
        grouptype: 65,
        pickUpLocationId: "",
      },
      logistics_user: "",
      pickUpLocationIds: "",
      batchIds: [],
    };
  },
  created() {
    this.pickUpLocation();
      //     this.$router.push({
      //   path:
      //     "/extractGoods/details?id=" +
      //    3705 +
      //     "&name=" +
      //     2 +
      //     "&state=" +
      //     "&queryType=3",
      // });
  },
  methods: {
    //点击送货
    delivery() {
      var that = this;
      if (this.batchIds == "") {
        this.$message.error("请勾选需要派送的订单");
        return false;
      }
      that
        .$confirm("确认送货？")
        .then(() => {
          var data = {
            batchIds: that.batchIds,
          };
          crudDept.deliveryOrder(data).then((res) => {
            that.$refs.multipleTable.clearSelection();
            that.pickUpLocation();
          });
        })
        .catch(() => {});
    },
    //查询高级账户自提点
    pickUpLocation() {
      if (typeof Cookies.get("logistics_user") == "string") {
        this.logistics_user = JSON.parse(Cookies.get("logistics_user"));
      } else {
        this.logistics_user = Cookies.get("logistics_user");
      }

      var data = {
        belongsToId: this.logistics_user.id,
        category: 2,
        sort: "number,asc",
      };
      crudDept.pickUpLocation(data).then((res) => {
        if (res.content != "") {
          var ids = res.content[0].id;

          // for (var i = 0; i < res.content.length; i++) {
          //   ids.push(res.content[i].id);
          // }

          this.screen.pickUpLocationId = res.content[0].id;
          this.pickUpLocationIds = res.content[0].id;
          this.orderList();
        }
      });
    },
    details(e, item) {
      localStorage.setItem("batch", JSON.stringify(item));
      var name = "待派送管理";
      this.$router.push({
        path:
          "/extractGoods/details?id=" +
          e +
          "&name=" +
          name +
          "&state=" +
          "&queryType=3",
      });
    },
    //筛查
    search() {
      if (this.screen.pickUpLocationId != "") {
        this.orderList();
      }
    },
    //重置
    reset() {
      this.screen = {
        page: 1,
        size: 10,
        aeronumber: "",
        ordernumber: "",
        queryType: 2,
        name: "",
        grouptype: 65,
        pickUpLocationId: this.pickUpLocationIds,
      };
      if (this.screen.pickUpLocationId != "") {
        this.orderList();
      }
    },
    toSelectRoute() {},
    handleSelectionChange(val) {
      var orderIds = [];
      for (var i = 0; i < val.length; i++) {
        orderIds.push(val[i].id);
      }
      this.batchIds = orderIds;
    },
    //分页

    pageChange(e) {
      this.screen.page = e;
      this.orderList();
    },

    //批次列表
    orderList() {
      this.tableLoading = true;
      crudDept
        .batch(this.screen)
        .then((res) => {
          this.orderData = res;
          this.tableLoading = false;
        })
        .catch((res) => {
          this.tableLoading = false;
        });
    },

    productInformation() {
      this.$router.push({ path: "/parcel/productInformation" });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
.el-divider--horizontal {
  margin: 0 0 24px !important;
}
.text_line {
  text-align: left !important;
}
.text_iop {
  width: 50%;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  margin: 0 45px;
  color: #333333;
  text-align: right;
}
.fill_in_list_fg {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
.text_btn {
  margin: 0 auto !important;
  display: block;
}
.el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  /* width: 27%; */
  border-bottom: 1px solid #dedede;
  /* padding-bottom: 10px; */
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-right: 22px;
}
.fill_in_list_l {
  display: flex;
  align-items: baseline;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.last_step_l {
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  line-height: 44px;
  border-radius: 22px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.step_box_s {
  display: flex;
  justify-content: flex-end;
  margin-top: 58px;
}
.confirm_btn {
  margin: 0 auto !important;
  background-color: #5178ff;
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  border-radius: 22px;
}
input::-webkit-input-placeholder {
  color: #999999;
}
input::-moz-input-placeholder {
  color: #999999;
}
input::-ms-input-placeholder {
  color: #999999;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  /* width: 27%; */
  border-bottom: 1px solid #dedede;
  /* padding-bottom: 10px; */
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-right: 22px;
}
.fill_in_list_l {
  display: flex;
  align-items: baseline;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #ff0e0e;
}
.numbers_info {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-bottom: 22px;
}
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: auto !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  /*height:600px;*/
  max-height: calc(100% - 30px) !important;
  max-width: calc(100% - 30px) !important;
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
.table_box {
  margin-top: 32px;
}
.el-table td,
.el-table th {
  text-align: center !important;
}
.text_li {
  color: #ffa401 !important;
}
.el-button.is-round {
  border-radius: 14px;
  width: 110px;
  height: 40px;
}
.table_item_box_s {
  display: flex;
}
.table_item_box_l_s {
  display: flex;
}
.table_item_input >>> .el-input__inner {
  background: none !important;
  outline: none !important;

  border: none;
  color: #fff !important;
  padding: 0;
}
.content_box_title {
  display: flex;
  align-items: center;
}
.circle_l {
  width: 18px;
  height: 18px;
  background: #5178ff;
  border-radius: 50%;
}
.circle_r {
  width: 18px;
  height: 18px;
  background: rgba(81, 120, 255, 0.27);
  border-radius: 50%;
  margin-left: -7px;
}
.text_xl {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  margin-left: 20px;
  color: #333333;
}
.content_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 38px 58px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.table_item_box {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 25px 0 0;
  box-sizing: border-box;
}
.table_item_box_l {
  margin-right: 30px;
  text-align: left;
}
.table_item_box_l_r {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #ffffff;

  border: 1px solid #dedede;
  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select {
  width: 100%;
  height: 40px;
  background: #ffffff;

  border: none;
  opacity: 1;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select >>> .el-input__inner {
  border: none !important;
  padding: 0 !important;
  width: 100% !important;
}
.input_select_table {
  padding: 0 !important;
  width: 180px;
  height: 40px;

  opacity: 1;
  border-radius: 10px;
  margin-left: 10px;
  padding: 0 15px !important;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #ff0e0e;
}
</style>


// WEBPACK FOOTER //
// src/views/SeniorAaccount/delivery.vue